var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hdPage)?_c('div',{staticClass:"hd-runtime-main",class:{fixedPage: _vm.isNotStarted || _vm.isExpired}},[_c(_vm.hdPage,{tag:"component",attrs:{"activityObj":_vm.formCustom}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cfb5f02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/vibrantRubikCube/runtime/hdmain.vue
// module id = null
// module chunks = 